import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="move-element-with-enter"
export default class extends Controller {
  connect() {
    console.log("moveElementWithEnterController connected");
  }

  call(event) {
    if (event.key !== "Enter") return;

    if (event.target.type === "submit" || event.target.type === "textarea") {
      return;
    }

    event.preventDefault();

    const activeElement = document.activeElement;

    const focusableElements = Array.from(
      this.element.querySelectorAll(
        "input:not(.skip-enter-focus), select:not(.skip-enter-focus), select-input:not(.skip-enter-focus), textarea:not(.skip-enter-focus)"
      )
    ).filter((element) => !element.disabled && element.type !== "hidden");

    const currentIndex = focusableElements.indexOf(activeElement);

    const nextIndex = (currentIndex + 1) % focusableElements.length;
    const nextElement = focusableElements[nextIndex];

    setTimeout(() => {
      nextElement.focus();
    }, 100);
  }
}
